<script>
import { debounce } from 'lodash';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    errors: {
      type: Array,
      default: () => [],
    },
    debounceTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedValueSetter: null,
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.$attrs.value;
      },
      set(newValue) {
        if (this.selectedValueSetter) {
          this.selectedValueSetter(newValue);
        } else {
          this.$emit('input', newValue);
        }
      },
    },
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  watch: {
    debounceTime: {
      immediate: true,
      handler(newDebounceTime) {
        if (newDebounceTime > 0) {
          this.selectedValueSetter = debounce((newValue) => {
            this.$emit('input', newValue);
          }, newDebounceTime);
        } else {
          this.selectedValueSetter = null;
        }
      },
    },
  },
};
</script>

<template>
  <div class="form-group">
    <label>{{ title }}</label>
    <div class="input-group">
      <input
        type="text"
        :placeholder="placeholder"
        :disabled="disabled"
        class="form-control form-control-sm"
        :value="selectedValue"
        @input="selectedValue = $event.target.value"
      />
      <span class="invalid-feedback" role="alert" :class="{ 'd-block': hasErrors }">
        <strong>{{ errors[0] }}</strong>
      </span>
    </div>
  </div>
</template>